import { connect } from 'react-redux';
import ConfirmEmailComponent from '../components/ConfirmEmailComponent';
import { confirmEmail, resendConfirmationEmail } from '../actions/ProfileActions';

const mapStateToProps = (state) => ({
    submitting: state.profile.submitting,
    emailConfirmed: state.profile.user.emailConfirmed,
    email: state.profile.user.email,
    name: state.profile.user.name,
    resending: state.profile.resending,
    statusOfEmailResent: state.profile.statusOfEmailResent,
});

const mapDispatchToProps = (dispatch) => ({
    confirmEmail: (userId, code) => {
        dispatch(confirmEmail(userId, code));
    },
    resendConfirmationEmail: (userId, name, email) => {
        dispatch(resendConfirmationEmail(userId, name, email));
    },
});

const ConfirmEmailContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ConfirmEmailComponent);

export default ConfirmEmailContainer;
